module.exports = __webpack_public_path__ + "img/certificate.1d2bd8c1.png";